import {
    GET_MACYS_ORDERS_REQUEST,
    GET_MACYS_ORDERS_SUCCESS,
    GET_MACYS_ORDERS_ERROR,
    ADD_MACYS_ORDERS_REQUEST,
    ADD_MACYS_ORDERS_SUCCESS,
    ADD_MACYS_ORDERS_ERROR,
    GET_MACYS_INVOICE_REQUEST,
    GET_MACYS_INVOICE_SUCCESS,
    GET_MACYS_INVOICE_ERROR,
    ADD_MACYS_INVOICE_REQUEST,
    ADD_MACYS_INVOICE_SUCCESS,
    ADD_MACYS_INVOICE_ERROR
} from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getMacysOrders = (token) => dispatch => {
    dispatch({ type: GET_MACYS_ORDERS_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getMacysOrders`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_MACYS_ORDERS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_MACYS_ORDERS_ERROR,
                payload: error.response,
            });
        })
}

export const SendMacysOrders = (token, value) => dispatch => {
    dispatch({ type: ADD_MACYS_ORDERS_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/sendMacysOrders`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        },
        data: value,
    })
        .then(response => {
            return dispatch({ type: ADD_MACYS_ORDERS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_MACYS_ORDERS_ERROR,
                payload: error.response,
            });
        })
}


export const getMacysInvoice = (token) => dispatch => {
    dispatch({ type: GET_MACYS_INVOICE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/MacysCustomerData`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: GET_MACYS_INVOICE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_MACYS_INVOICE_ERROR,
                payload: error.response,
            });
        })
}

export const sendMacysInvoice = (token, data) => dispatch => {
    dispatch({ type: ADD_MACYS_INVOICE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/sendMacysInvoices`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            invoice_ids : data
        }
    })
        .then(response => {
            return dispatch({
                type: ADD_MACYS_INVOICE_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: ADD_MACYS_INVOICE_ERROR, payload: error.response });
        });
};

